import { AdvertiserAccount as Api } from '@synapex/shared2/gateway-rest-api';

import { api, pickDto } from '@/shared/api';

import * as ReplyParser from './reply-parser';
import { SnakeIdObj } from '@synapex/tools/typescript';

//query

export const all = () =>
  api.get<Api.AllReply>('advertiser-account').then(ReplyParser.allReply);

//mutations

export const create = () => (dto: Api.CreateInputDto) =>
  api
    .post<Api.CreatedReply>(
      'advertiser-account',
      pickDto(Api.CreateInputDto, dto),
    )
    .then(ReplyParser.createdReply);

export const putNewAccountChannelRequest =
  () => (body: Api.ChannelRequest.putNewAccount.Body) =>
    api
      .put<Api.ChannelRequest.putNewAccount.Reply>(
        'advertiser-account/channel-request',
        body,
      )
      .then((r) => ReplyParser.newAccountChannelRequest(r.channelRequest));

export const update =
  ({ advertiser_account_id }: SnakeIdObj<'advertiser_account'>) =>
  (dto: Api.UpdateInputDto) =>
    api
      .put<Api.OneReply>(
        `advertiser-account/${advertiser_account_id}`,
        pickDto(Api.UpdateInputDto, dto),
      )
      .then(ReplyParser.advertiserAccount);

//

export const createSite =
  ({ advertiser_account_id }: SnakeIdObj<'advertiser_account'>) =>
  (dto: Api.Site.CreateInputDto) =>
    api
      .post<Api.Site.Reply>(
        `advertiser-account/${advertiser_account_id}/site`,
        pickDto(Api.Site.CreateInputDto, dto),
      )
      .then(ReplyParser.workspace);

export const putChannelRequest =
  ({ advertiser_account_id }: SnakeIdObj<'advertiser_account'>) =>
  (dto: Api.ChannelRequest.putExistentAccount.Body) =>
    api
      .put<Api.ChannelRequest.putExistentAccount.Reply>(
        `advertiser-account/${advertiser_account_id}/channel-request`,
        dto,
      )
      .then((r) => ReplyParser.existentAccountChannelRequest(r.channelRequest));

export const deleteChannelRequest =
  (params: Api.ChannelRequest.deleteOne.Params) => (): Promise<void> =>
    api.delete(Api.ChannelRequest.deleteOne.path(params));
